import { put, call, takeLatest } from 'redux-saga/effects';

import { HealthQuoteApi } from '@apis/HealthQuoteApi';
import { HealthQuoteCompare } from '@models/HealthQuote';
import { SagaPayload } from '@utils/typescript';

import {
  healthQuotesFetch,
  HealthQuotesFetchPayload,
  stateUpdate,
  StateUpdatePayload,
} from './action';

function* handleHealthQuotesFetch({ payload }: SagaPayload<HealthQuotesFetchPayload>) {
  const state: StateUpdatePayload = { healthQuotes: null };
  try {
    state.healthQuotes = (yield call(HealthQuoteApi.compare, payload)) as HealthQuoteCompare[];
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

export default function* () {
  yield takeLatest(healthQuotesFetch, handleHealthQuotesFetch);
}
